import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC } from 'react'
import { creditCardExpirationDate } from '@sales-center/common'
import {
  PaymentMethod,
  PaymentMethodAccountTypes,
} from '@user/store/payments/typings'
import { splitCamelCase } from '@sales-center/common'

import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

const getStyles = (theme: Theme) => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
})

interface Props {
  paymentMethod: PaymentMethod
}

export const Row: FC<Props> = (props: Props) => {
  const { paymentMethod } = props
  const styles = getStyles(useTheme())
  return (
    <TableRow sx={styles.root}>
      <TableCell component="th" scope="row">
        {paymentMethod.nameOnCard}
      </TableCell>
      <TableCell>
        {paymentMethod.accountType == PaymentMethodAccountTypes.CreditCard
          ? splitCamelCase(paymentMethod.creditCardType)
          : paymentMethod.accountType}
      </TableCell>
      <TableCell>{paymentMethod.accountNumber}</TableCell>
      <TableCell>
        {paymentMethod.accountType == PaymentMethodAccountTypes.CreditCard
          ? creditCardExpirationDate(paymentMethod.expirationDate)
          : ''}
      </TableCell>
      <TableCell>
        {paymentMethod.isPrimary && (
          <CheckCircleIcon
            color="primary"
            fontSize="small"
            data-test-id={`primaryPaymentMethodIcon-${paymentMethod.id}`}
          />
        )}
      </TableCell>
    </TableRow>
  )
}
